import { authedFetch } from './http';

type Auth = { getToken: () => string | null; hydrate: () => Promise<void> };

export type Question = { key: string; label: string; type: string; required: boolean; options?: string[] };

export type Voucher = {
  id: number;
  kind: 'drink' | 'article';
  state: string;
  issuedAt: string;
  partnerName?: string;
  partnerNote?: string;
  qrToken?: string;
  matchNumber?: number;
  drinkSize?: string;
  label?: string;
  litres?: number;
  articleId?: number;
  articleTitle?: string;
  articleImage?: string;
  questions?: Question[];
  answers?: Record<string, string>;
};

export async function listVouchers(auth: Auth): Promise<Voucher[]> {
  const body = await authedFetch<{ vouchers: Voucher[] }>(auth.getToken, auth.hydrate, '/api/me/vouchers');
  return body.vouchers ?? [];
}

/** PATCH /api/me/vouchers/{id}/answers — fill in article-prize questions. */
export async function submitVoucherAnswers(
  auth: Auth,
  id: number,
  answers: Record<string, string>,
): Promise<void> {
  await authedFetch(auth.getToken, auth.hydrate, `/api/me/vouchers/${id}/answers`, {
    method: 'PATCH',
    body: JSON.stringify({ answers }),
  });
}
